import { useCallback, useEffect, useState } from 'react';
import { toast } from '@wit-support/ui';
const POPUP_FEATURES = 'width=520,height=640,menubar=no,toolbar=no,location=yes,status=yes';
const POPUP_NAME = 'wit-google-oauth';
const CLOSED_POLL_MS = 600;
/**
 * Shared Google OAuth popup lifecycle: open the named popup window, listen
 * for the callback page's `postMessage`, and poll for the user closing it.
 * Extracted from CreateChannelDialog's `GmailConnectMode` and
 * EditChannelDialog's `ReconnectGoogleRow`, which previously copied this
 * ~20-line protocol (window name, message shape, poll interval) verbatim —
 * see M-027.
 */
export function useGoogleOAuthPopup({ onDone }) {
    const [popup, setPopup] = useState(null);
    const openPopup = useCallback((authUrl) => {
        const w = window.open(authUrl, POPUP_NAME, POPUP_FEATURES);
        if (!w) {
            toast.error('Popup blocked — allow popups and retry.');
            return;
        }
        setPopup(w);
    }, []);
    useEffect(() => {
        if (!popup)
            return;
        function onMessage(e) {
            const data = e.data;
            if (data?.kind === 'google-oauth' && data.status === 'done') {
                onDone(true);
            }
        }
        const poll = window.setInterval(() => {
            if (popup.closed) {
                window.clearInterval(poll);
                onDone(false);
            }
        }, CLOSED_POLL_MS);
        window.addEventListener('message', onMessage);
        return () => {
            window.clearInterval(poll);
            window.removeEventListener('message', onMessage);
        };
    }, [popup, onDone]);
    return { popup, openPopup };
}
//# sourceMappingURL=use-google-oauth-popup.js.map